import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {
    FileAttachment,
    FileAttachmentsV1Service,
    Task,
    TasksV1Service
} from "../../../apis/backend";
import {firstValueFrom, mergeMap} from "rxjs";
import {
    TaskDialogComponent,
    TaskStatusDisplayValues
} from "../dialog/task-dialog.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileAttachmentComponent} from "../../../components/file-attachments/file-attachment/file-attachment.component";
import {DefaultPriorityColor, PriorityColorMap} from "../utils/priority";
import {EstimateTextareaHeight} from "../../../utils/text";

@Component({
    selector: 'task',
    templateUrl: './task-detail.component.html',
})
export class TaskDetailComponent implements OnInit {
    
    public Task: Task;
    
    public TaskStatusDisplayValues = TaskStatusDisplayValues;
    
    public PriorityColorMap = PriorityColorMap;
    public DefaultPriorityColor = DefaultPriorityColor;
    
    public EditMode = false;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service,
                private _taskService: TasksV1Service,
                private _modalService: NgbModal,
                private _route: ActivatedRoute) {}
    
    ngOnInit() {
        this._route.params
            .pipe(
                mergeMap(params => {
                    return this._taskService.getTask(params['taskID']);
                })
            )
            .subscribe(task => {
                this.Task = task;
            });
    }

    public EditTask() {
        if (this.Task) {
            let task = <Task>JSON.parse(JSON.stringify(this.Task));

            let modal = this._modalService.open(TaskDialogComponent, { size: 'lg' });
            modal.componentInstance.Task = task;

            modal.result
                .then((task: Task) => {
                    return firstValueFrom(this._taskService.updateTask(task.TaskID, task));
                })
                .then((task: Task) => {
                    this.Task = task;
                });
        }
    }

    public GetNotesInputHeight() {
        return EstimateTextareaHeight(this.Task.Notes || '');
    }

    public FileUploader() {
        return (file: File) => {
            return firstValueFrom(this._taskService.uploadFileAttachment(
                this.Task.TaskID,
                file));
        }
    }

    public FileDeleter() {
        return (fileAttachment: FileAttachment) => {
            return firstValueFrom(this._taskService.deleteFileAttachment(
                this.Task.TaskID,
                fileAttachment.FileAttachmentID));
        }
    }
}